import React from 'react'


import img1 from "../../assets/img/chess.png"
import img2 from "../../assets/img/brain.png"
import img3 from "../../assets/img/ai_human.png"


const Research = () => {


    const images = [
      {
        "imaga": img1,
        "author": "OpenPolitica",
        "title": "Research Paper 1",
        "desc": "Hello! We are planning to construct new infrastructure that would provide clean energy to the surrounding areas. We are partnered with SolarNow! and are currently in the crowdfunding stage of our operations..."
      },
      {
        "imaga": img2,
        "author": "OpenPolitica",
        "title": "Research Paper 2",
        "desc": "Hello! We are planning to construct new infrastructure that would provide clean energy to the surrounding areas. We are partnered with SolarNow! and are currently in the crowdfunding stage of our operations..."
      },
      {
        "imaga": img3,
        "author": "OpenPolitica",
        "title": "Research Paper 3",
        "desc": "Hello! We are planning to construct new infrastructure that would provide clean energy to the surrounding areas. We are partnered with SolarNow! and are currently in the crowdfunding stage of our operations..."
      }
    ]


 
  return (
    <section className='my-10'>

      <div className='my-6'>
       <h1 className='text-3xl font-bold text-white text-center'>
         Our platform is backed by research.
       </h1>
      </div>


      <div className='flex md:justify-center overflow-x-scroll lg:overflow-x-hidden space-x-[60px] text-white '>
            {images.map((item, index) => (
                <div key={index} className='flex-shrink-0  md:flex-none  w-[95vw] md:w-[30%]'>
                <div className='h-[300px] w-full'>
                  <img src={item.imaga} className='w-full h-full' alt='research papers' />
                </div>
                <div className='my-8 space-y-4'>
                  <p className='font-bold'>{item.title}</p>
                  <p>By: <b>{item.author}</b></p>

                  <p className='py-3'>{item.desc}</p>
                </div>
                </div>
            ))}
        </div>
    </section>
  )
}

export default Research